
"use client";

import React, { useState } from "react";

const FiveKMenu = () => {
    const [activeOverlay, setActiveOverlay] = useState(null);

    const overlays = [
        {
            buttonTitle: "Start Here",
            title: "Make the Most Out of Your Training Plan",
            content:
                "Learn how to create your training plan and use all the personalization features.",
            videoUrl: "https://player.vimeo.com/video/1058344317",
        },
        {
            buttonTitle: "Warm-Up",
            title: "Race-Day Warm-Up Routine",
            content:
                "This warmup will get your body ready for the race. I've been doing it more more than 10 years with great success. I recommend practicing it before your threshold runs. You don't need to do any running. This warmup is enough.",
            videoUrl: "https://player.vimeo.com/video/845348268",
        },
        {
            buttonTitle: "Strategy",
            title: "Race-Day Strategy",
            content: "Learn the 3-part evidence-based strategy to run your best 5k",
            videoUrl: "https://player.vimeo.com/video/1058346657",
        },
        {
            buttonTitle: "Extra Tips",
            title: "Final Thoughts",
            content: "My top 5 extra tips to achieve a nre 5k PR",
            videoUrl: "https://player.vimeo.com/video/1058346522",
        },
        {
            buttonTitle: "The Science",
            title: "The Why behind the plan",
            content:
                "Learn why the plan is structured the way it is and how it will help you reach your goals.",
            videoUrl: "https://player.vimeo.com/video/1058346036",
        },
    ];

    const handleOverlayClick = (index) => {
        setActiveOverlay(index);
    };

    return (
        <div className="mb-4 text-center p-2">
            {/* Grid with 2 columns on mobile and 4 on small screens+ */}
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
                {overlays.map((overlay, index) => (
                    <button
                        key={index}
                        onClick={() => handleOverlayClick(index)}
                        className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
                    >
                        {overlay.buttonTitle}
                    </button>
                ))}
            </div>

            {activeOverlay !== null && (
                <div
                    className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center"
                    onClick={() => setActiveOverlay(null)}
                >
                    <div
                        className="bg-white p-4 rounded-md m-4 relative max-w-2xl w-full max-h-[80vh] overflow-y-auto"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={() => setActiveOverlay(null)}
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-full w-8 h-8 flex items-center justify-center transition-colors"
                        >
                            ✕
                        </button>

                        <h2 className="text-xl font-bold mb-2">
                            {overlays[activeOverlay].title}
                        </h2>

                        <p className="mb-4">{overlays[activeOverlay].content}</p>

                        {/* Responsive Vimeo Embed */}
                        <div className="relative pb-[56.25%] overflow-hidden rounded">
                            <iframe
                                src={overlays[activeOverlay].videoUrl}
                                title={overlays[activeOverlay].title}
                                className="absolute top-0 left-0 w-full h-full"
                                frameBorder="0"
                                allow="autoplay; fullscreen; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FiveKMenu;
